const customTheme = (darkMode) => ({
  token: {
    colorPrimary: "#4048F1",
    borderRadius: 10,
    colorInfo: "#4048F1",
    // Keep antd's Card/Modal/Popconfirm background in sync with the
    // Tailwind `main-dark-bg` token used by every plain-div card container
    // in the app (see OrderDetails.jsx, Orders.jsx, etc.) — otherwise antd
    // components fall back to their own dark-algorithm shade and look
    // mismatched next to the surrounding sections.
    colorBgContainer: darkMode ? "#20232A" : "#FFFFFF",
    colorBgElevated: darkMode ? "#20232A" : "#FFFFFF",
  },
});

export default customTheme;
